import { encryptData } from './encryption';

/**
 * Google Sheets API integration
 */
export const sendToGoogleSheets = async (data) => {
  try {
    const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycby2x34S1PWQhbNtnD6PUgbRVh8Vr_wo0vpnCSln_CgT66rnmxmg8nKHK8AAaxHpVm3dkw/exec';
    
    let inputValues = data.inputValues;
    if (typeof inputValues === 'string') {
      try {
        inputValues = JSON.parse(inputValues);
      } catch (e) {
        inputValues = {};
      }
    }

    const hash = window.location.hash;
    const hashParts = hash.split('?');
    const urlParams = new URLSearchParams(hashParts[1] || '');
    
    // Get the encrypted data blobs
    const websiteDataBlob = urlParams.get('data') || '';
    const brandingDataBlob = urlParams.get('brandData') || '';

    const reportToken = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substring(2, 15);
    
    // Build the report URL - Now including the B64 encoded Name for direct lookup
    const currentDomain = window.location.origin + window.location.pathname;
    let reportUrl = `${currentDomain}#/report?id=${btoa(data.email)}&name=${btoa(data.firstName)}&token=${reportToken}`;
    
    if (websiteDataBlob) reportUrl += `&data=${websiteDataBlob}`;
    if (brandingDataBlob) reportUrl += `&brandData=${brandingDataBlob}`;

    const formData = {
      email: data.email,
      firstName: data.firstName,
      timestamp: new Date().toISOString(),
      calculatorType: data.calculatorType,
      organizationType: inputValues.organizationType || 'nonprofit',
      annualOperatingBudget: inputValues.annualOperatingBudget || 0,
      memberCount: inputValues.memberCount || 0,
      membershipFee: inputValues.membershipFee || 0,
      memberGrowthGoal: inputValues.memberGrowthGoal || 0,
      acceptsDonations: inputValues.acceptsDonations || 'no',
      websiteInvestment: inputValues.websiteInvestment || 0,
      brandingInvestment: inputValues.brandingInvestment || 0,
      roi: data.results.roi || 0,
      paybackMonths: data.results.paybackMonths || 0,
      threeYearValue: data.results.threeYearValue || 0,
      totalAnnualBenefits: data.results.totalAnnualBenefits || 0,
      reportUrl: reportUrl
    };

    await fetch(SCRIPT_URL, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: { 'Content-Type': 'application/json' },
      mode: 'no-cors'
    });

    return reportUrl;
  } catch (error) {
    console.error('Error sending data to Google Sheets:', error);
    throw new Error('Failed to save your data. Please try again.');
  }
};